export function Markdown({ text = "" }) {
  const lines = String(text).split("\n");
  const blocks = [];
  let list = [];
  const flush = (key) => {
    if (list.length) {
      blocks.push(
        <ul key={`ul-${key}`} className="my-2 list-disc space-y-1 pl-6 text-slate-700">
          {list.map((it, i) => <li key={i}>{inline(it)}</li>)}
        </ul>
      );
      list = [];
    }
  };
  lines.forEach((raw, idx) => {
    const line = raw.trimEnd();
    if (/^###\s+/.test(line)) { flush(idx); blocks.push(<h4 key={idx} className="mt-3 text-base font-bold text-slate-900">{inline(line.replace(/^###\s+/, ""))}</h4>); }
    else if (/^##\s+/.test(line)) { flush(idx); blocks.push(<h3 key={idx} className="mt-4 text-lg font-extrabold text-slate-900">{inline(line.replace(/^##\s+/, ""))}</h3>); }
    else if (/^#\s+/.test(line)) { flush(idx); blocks.push(<h2 key={idx} className="mt-4 text-xl font-extrabold text-slate-900">{inline(line.replace(/^#\s+/, ""))}</h2>); }
    else if (/^[-*]\s+/.test(line)) { list.push(line.replace(/^[-*]\s+/, "")); }
    else if (line.trim() === "") { flush(idx); }
    else { flush(idx); blocks.push(<p key={idx} className="my-1.5 leading-relaxed text-slate-700">{inline(line)}</p>); }
  });
  flush("end");
  return <div className="text-sm">{blocks}</div>;
}

function inline(str) {
  const parts = str.split(/(\*\*[^*]+\*\*)/g);
  return parts.map((p, i) =>
    /^\*\*[^*]+\*\*$/.test(p) ? <strong key={i} className="font-bold text-slate-900">{p.slice(2, -2)}</strong> : <span key={i}>{p}</span>
  );
}
